import { useEffect } from "react";

import { tryRefreshToken } from "repositories/clients/rest";

const useRefreshToken = (isInitialLoad=false) => {

    useEffect(() => {

        const refresh = async () => {
            console.debug("always refresh token on any page reloading...");

            await tryRefreshToken(isInitialLoad);
        };

        refresh();

        // eslint-disable-next-line 
    }, [])
}

export default useRefreshToken;